import React from 'react'
import { Button, Col, Label, Row } from 'reactstrap'
import Loading from 'components/Loading/Loading'
import ErrorBoundary from 'components/ErrorBoundary'
import SitesResultsGrid from '../SitesResultsGrid'
import SearchCriteriaBadges from 'components/SearchCriteriaBadges'
import { SiteFilters, Site } from 'types'

interface SitesSearchProps {
  criteria: Partial<SiteFilters>
  sites?: Site[]
  isLoading: boolean
  clearSearch: () => void
  search: () => void
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleKeydown: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

const SitesSearch: React.FC<SitesSearchProps> = ({
  criteria,
  clearSearch,
  isLoading,
  handleChange,
  handleKeydown,
  search,
  sites,
}) => {
  const showSearchResults = sites !== null
  const disableSearch = Object.keys(criteria).length === 0

  return (
    <React.Fragment>
      {showSearchResults && (
        <div className="float-right">
          <Button color="primary" onClick={clearSearch} outline>
            <i className="fas fa-search" />
            &nbsp;New Search
          </Button>
        </div>
      )}
      <h2>Site Search</h2>
      <hr />
      <ErrorBoundary>
        <Loading isLoading={isLoading} message="Searching..." />
        {!showSearchResults && (
          <React.Fragment>
            <Row>
              <Col md={12} sm={12}>
                <fieldset>
                  <div className="form-group" data-testid="siteId-search-form">
                    <Label for="site-id-input">Site Id</Label>
                    <input
                      className="form-control"
                      id="site-id-input"
                      name="siteId"
                      onChange={handleChange}
                      onKeyDown={handleKeydown}
                      type="number"
                      value={criteria.siteId || ''}
                    />
                  </div>
                  <div
                    className="form-group"
                    data-testid="organizationId-search-form"
                  >
                    <Label for="organization-id-input">Organization Id</Label>
                    <input
                      className="form-control"
                      id="organization-id-input"
                      name="organizationId"
                      onChange={handleChange}
                      onKeyDown={handleKeydown}
                      type="number"
                      value={criteria.organizationId || ''}
                    />
                  </div>
                  <div
                    className="form-group"
                    data-testid="nsCustomerId-search-form"
                  >
                    <Label for="nscustomer-id-input">NS Customer Id</Label>
                    <input
                      className="form-control"
                      id="nscustomer-id-input"
                      name="nsCustomerId"
                      onChange={handleChange}
                      onKeyDown={handleKeydown}
                      type="number"
                      value={criteria.nsCustomerId || ''}
                    />
                  </div>
                </fieldset>
              </Col>
            </Row>

            <hr />
            <div className="text-right">
              <Button
                className="btn-fixed-width"
                color="link"
                data-testid="clear-button"
                onClick={clearSearch}
              >
                Clear
              </Button>
              <Button
                className="btn-fixed-width"
                color="primary"
                data-testid="search-button"
                disabled={disableSearch}
                onClick={search}
              >
                <i className="fas fa-search" />
                &nbsp;Search
              </Button>
            </div>
          </React.Fragment>
        )}
        {showSearchResults && sites && (
          <div>
            <React.Fragment>
              <SearchCriteriaBadges
                clearSearch={clearSearch}
                managerType={'sitesManager.sites'}
              />
              <hr />
            </React.Fragment>
            <Row>
              <SitesResultsGrid sites={sites} />
            </Row>
          </div>
        )}
      </ErrorBoundary>
    </React.Fragment>
  )
}

export default SitesSearch
